import {
  ICmFilter,
  ICmService,
  ICmServiceActionHandler,
  ICmServiceCard,
  ICmServiceInitialState,
  ICmServiceResponse
} from './interfaces';
import {
  CmServiceActionsType,
  CM_FILTER_LOADED,
  COUNTY_FILTER_LOADED,
  SERVICES_LOADED,
  SERVICE_LOADED,
  SELECTED_FILTER_LOADED,
  COUNTY_FILTER_CLEARED,
  SERVICE_CHECK_FAVORITE,
  SERVICE_UNCHECK_FAVORITE,
  REFERRALS_LOADED,
  SERVICE_CHECK_REFERRALS,
  SERVICE_UNCHECK_REFERRALS,
  SET_SEND_REFERRALS_STATUS,
  SERVICES_ORG_LOADED,
  STRING_FILTER_LOADED,
  FAVORITE_FILTER_LOADED
} from './actions';
import {CmFilterModel} from '../../components/cm-filters/CmFilterModels';
import {CmServiceFilterType} from '../../components/cm-filters/CmFilterEnums';

const CmServiceInitialState: ICmServiceInitialState = {
  services: [],
  service: null,
  page: null,
  filters: [],
  selectedFilters: {},
  searchStringFilter: null,
  favoritesFilter: null,
  referrals: [],
  sendReferralsStatus: false,
  servicesOrg: [],
  pageOrg: null
};

const setFilters = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    filters: payload as ICmFilter[]
  };
};

const setSelectedFilters = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    selectedFilters: payload as Record<string, CmFilterModel>
  };
};

const setStringFilter = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    searchStringFilter: payload as ICmFilter
  };
};

const setFavoriteFilter = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    favoritesFilter: payload as ICmFilter
  };
};

const setCountyFilters = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    filters: [...state.filters, payload as ICmFilter]
  };
};

const clearCountyFilters = ({
  state
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    filters: state.filters.filter(f => f.name !== CmServiceFilterType.cmCounties)
  };
};

const setCmServices = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  const {
    data,
    page
  } = payload as ICmServiceResponse;

  return {
    ...state,
    services: page.pageNumber === 0 ? data : [...state.services, ...data],
    page: page
  };
};

const setCmServicesOrg = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  const {
    data,
    page
  } = payload as ICmServiceResponse;

  return {
    ...state,
    servicesOrg: page.pageNumber === 0 ? data : [...state.servicesOrg, ...data],
    pageOrg: page
  };
};

const setReferrals = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    referrals: payload as ICmService[]
  };
};

const setCmService = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    service: payload as ICmServiceCard
  };
};

const checkFavorite = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    referrals: state.referrals.map((item) => {
      if (item.srvId === payload) {
        return {
          ...item,
          favorite: true
        };
      }

      return item;
    }),
    services: state.services.map((item) => {
      if (item.srvId === payload) {
        return {
          ...item,
          favorite: true
        };
      }

      return item;
    })
  };
};

const uncheckFavorite = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    referrals: state.referrals.map((item) => {
      if (item.srvId === payload) {
        return {
          ...item,
          favorite: false
        };
      }

      return item;
    }),
    services: state.services.map((item) => {
      if (item.srvId === payload) {
        return {
          ...item,
          favorite: false
        };
      }

      return item;
    })
  };
};

const checkReferral = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    referrals: state.referrals.map((item) => {
      if (item.srvId === payload) {
        return {
          ...item,
          material: true
        };
      }

      return item;
    }),
    services: state.services.map((item) => {
      if (item.srvId === payload) {
        return {
          ...item,
          material: true
        };
      }

      return item;
    })
  };
};
const uncheckReferral = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  const uncheckIds = payload as number[];

  return {
    ...state,
    referrals: state.referrals.map((item) => {
      if (uncheckIds.includes(item.srvId)) {
        return {
          ...item,
          material: false
        };
      }

      return item;
    }),
    services: state.services.map((item) => {
      if (uncheckIds.includes(item.srvId)) {
        return {
          ...item,
          material: false
        };
      }

      return item;
    })
  };
};

const setSendReferralsStatus = ({
  state,
  payload
}: ICmServiceActionHandler): ICmServiceInitialState => {
  return {
    ...state,
    sendReferralsStatus: payload as boolean
  };
};

const cmServiceReducerHandlers = new Map([
  [CM_FILTER_LOADED, setFilters],
  [COUNTY_FILTER_LOADED, setCountyFilters],
  [SERVICES_LOADED, setCmServices],
  [SERVICE_LOADED, setCmService],
  [SELECTED_FILTER_LOADED, setSelectedFilters],
  [COUNTY_FILTER_CLEARED, clearCountyFilters],
  [REFERRALS_LOADED, setReferrals],
  [SERVICE_CHECK_FAVORITE, checkFavorite],
  [SERVICE_UNCHECK_FAVORITE, uncheckFavorite],
  [SERVICE_CHECK_REFERRALS, checkReferral],
  [SERVICE_UNCHECK_REFERRALS, uncheckReferral],
  [SET_SEND_REFERRALS_STATUS, setSendReferralsStatus],
  [SERVICES_ORG_LOADED, setCmServicesOrg],
  [STRING_FILTER_LOADED, setStringFilter],
  [FAVORITE_FILTER_LOADED, setFavoriteFilter]
]);

const cmServiceReducer = (state = CmServiceInitialState, action: CmServiceActionsType): ICmServiceInitialState => {
  const handler = cmServiceReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<ICmServiceActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default cmServiceReducer;
